import { queryOptions } from "@tanstack/react-query";
import { GET_USER_PREFERENCES } from "~/constants/apiEndpoints";
import { apiClient } from "~/lib/apiClient";
import { getCurrentApplicationId } from "~/lib/applicationId";
import { queryKeys } from "~/lib/queryKeys";

/**
 * 保存済みの好み（`userdb.user_preferences`）。`get_user_inf` の `preferred_*` とは別物。
 *
 * 答えていない軸はキーごと返らず、「どちらでもよい」は空配列で返る。
 * 受け取り側で空配列に潰さないこと。
 */
export type UserPreferencesResponse = {
  /** 好みの性格。4=Sっぽい / 5=Mっぽい */
  personalities?: number[];
  /** 好みのバスト。1=控えめ / 2=ふつう / 3=大きめ */
  bust_sizes?: number[];
  /** 好みの年齢帯。1=若め / 2=熟女 / 3=JD */
  age_ranges?: number[];
  /** 好みの婚姻。1=未婚 / 2=人妻 */
  marriage_statuses?: number[];
  /** 好みの口調。1=ギャル / 2=清楚 */
  speech_styles?: number[];
  /** 好みの体型。**画面の選択肢の番号**（1=スレンダー 〜 6=長身） */
  body_types?: number[];
  /** どう始めたいか。1=すぐ通話 / 2=少し話してから / 3=チャット中心 */
  step_to_calls?: number[];
  /** 顔出しを求めるか。1=顔出しOKの子がいい */
  showing_face_statuses?: number[];
  /** 無言通話。1=無言OK / 2=ちゃんと話したい */
  silent_ok_statuses?: number[];
  /** 会話スタイル。1=雑談 / 2=疑似恋愛 / 3=即エロ希望 */
  chat_styles?: number[];
  /** 女性に求めるHレベルの下限。0=こだわらない / 1〜5 */
  min_h_level?: number;
  /** 引っ張ってほしい度 1〜5 */
  lead_level?: number;
  /** されたいことの生の回答 */
  wants?: number[];
  /** 絞り込みが実際に効く好みを持っているか。「どちらでもよい」だけなら false */
  has_matching_axis: boolean;
  /** 答えた軸の数（「どちらでもよい」も1つと数える） */
  answered_axis_count: number;
};

/**
 * 保存済みの好みを取る。未登録でも成功し `has_matching_axis: false` が返る。
 * ほぼ変わらないので長めにキャッシュする。
 */
export const userPreferencesQueryOptions = queryOptions({
  queryKey: queryKeys.userPreferences.detail(),
  queryFn: () =>
    apiClient<UserPreferencesResponse>(GET_USER_PREFERENCES, {
      application_id: getCurrentApplicationId(),
    }),
  staleTime: 60 * 60 * 1000,
  gcTime: 60 * 60 * 1000,
});
